import { render, staticRenderFns } from "./rolemanage.vue?vue&type=template&id=96b68432&scoped=true&"
import script from "./rolemanage.vue?vue&type=script&lang=js&"
export * from "./rolemanage.vue?vue&type=script&lang=js&"
import style0 from "./rolemanage.vue?vue&type=style&index=0&id=96b68432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b68432",
  null
  
)

export default component.exports